let audioContext: AudioContext | null = null;

const context = () => {
  audioContext ??= new AudioContext();
  return audioContext;
};

export const playTone = (frequency = 520, duration = 0.08, gain = 0.035) => {
  try {
    const ctx = context();
    const oscillator = ctx.createOscillator();
    const volume = ctx.createGain();
    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(
      frequency * 1.15,
      ctx.currentTime + duration,
    );
    volume.gain.setValueAtTime(gain, ctx.currentTime);
    volume.gain.exponentialRampToValueAtTime(
      0.0001,
      ctx.currentTime + duration,
    );
    oscillator.connect(volume).connect(ctx.destination);
    oscillator.start();
    oscillator.stop(ctx.currentTime + duration);
  } catch {
    // Sound is a progressive enhancement and may be blocked by the browser.
  }
};

export const playSuccess = () => {
  playTone(440, 0.18, 0.04);
  window.setTimeout(() => playTone(660, 0.22, 0.04), 120);
  window.setTimeout(() => playTone(880, 0.3, 0.035), 250);
};
